import { useEffect } from "react"
import { useTranslation } from "react-i18next";
import { useRouter } from "@/lib/router-helpers"
import { ArrowLeft } from "lucide-react"

import { useBookingStore } from "@/store/booking-store"

export default function BookingSummary({ mode = "booking", appointmentId }: { mode?: "booking" | "reschedule", appointmentId?: string }) {
  const router = useRouter()
  const { t } = useTranslation()
  const { 
    selectedBranch, 
    selectedService, 
    selectedDate, 
    selectedSlot, 
    lastSlotSelectionTime
  } = useBookingStore()

  // Trigger flow when slot is selected
  useEffect(() => {
    if (selectedSlot && selectedDate && selectedBranch && selectedService) {
      onContinue()
    }
  }, [selectedSlot, selectedDate, selectedBranch, selectedService, lastSlotSelectionTime])

  function onContinue() {
    if (!selectedBranch || !selectedService || !selectedDate || !selectedSlot) {
      return
    }
    
    // Navigate to the mode selection page
    const params = new URLSearchParams()
    if (mode) params.append("mode", mode)
    if (appointmentId) params.append("appointmentId", appointmentId)
    
    router.push(`/booking/mode?${params.toString()}`)
  }

  return (
    <>
      <div className="flex items-center justify-between mt-12 pt-6 border-t border-gray-100">
          <button 
          onClick={() => router.back()} 
          className="group px-8 h-12 flex items-center gap-2 rounded-full border border-gray-200 bg-white text-gray-900 text-sm font-semibold hover:border-pink-500 hover:text-pink-600 transition-all duration-300 shadow-sm hover:shadow-md active:scale-95"
        >
          <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
          {t("back")}
        </button>
      </div>
    </>
  );
}